import ModuleActions from '@/constants/moduleActions'
import { parse as parseDate, differenceInDays } from 'date-fns'

export default {
  data: () => ({
    daysMarkedAsNew: 14
  }),
  computed: {
    module () {
      return this.$store.getters['searchStore/searchModules/getModule'](this.connectionId)
    },
    hasReadAction () {
      const moduleHasReadAction = this.module.actions?.includes(ModuleActions.READ) ?? false
      if (!moduleHasReadAction) return false
      return this.hasLicense
    },
    hasRequestAction () {
      const moduleHasRequestAction = (this.module.actions?.includes(ModuleActions.REQUEST) ?? false) && this.publication.rentable === '1'
      if (!moduleHasRequestAction) return false
      return !!(this.$store.getters.getClient?.email ?? false)
    },
    hasShopAction () {
      const moduleHasShopAction = this.module.actions?.includes(ModuleActions.SHOP) ?? false
      if (!moduleHasShopAction) return false
      return !!(this.publication.price || this.publication.price === 0)
    },
    hasOpenInBibisAction () {
      const moduleHasOpenInBibisAction = this.module.actions?.includes(ModuleActions.OPEN_IN_BIBIS) ?? false
      if (!moduleHasOpenInBibisAction) return false
      return !!(this.$store.getters.userHasAdminRole)
    },
    priceDisplay () {
      if (!this.hasShopAction) return null

      if (this.publication.price === 0) {
        return this.capitalize(this.$t('shop.library.items.free'))
      }

      return this.$filters.currency(this.publication.price, this.publication.currency)
    },
    isNew () {
      if (!this.publication.created && !this.publication.licenseCreated) return false

      const createdDateString = this.publication.created || this.publication.licenseCreated
      const validCreatedDateString = createdDateString.includes('T') ? createdDateString.replace('T', ' ') : createdDateString
      const bookCreatedDate = parseDate(validCreatedDateString, 'yyyy-MM-dd HH:mm:ss', new Date())
      const now = new Date()
      return differenceInDays(now, bookCreatedDate) < this.daysMarkedAsNew
    },
    hasLicense () {
      return !!(this.publication.pubkey)
    }
  }
}
